module.exports = __webpack_public_path__ + "img/templum_tech_Normal_ua.57905732.webp";